import { render } from "./ResourceTableSheet.vue?vue&type=template&id=fb250916"
import script from "./ResourceTableSheet.vue?vue&type=script&lang=js"
export * from "./ResourceTableSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__